import React, { useEffect, useRef, useState } from 'react'
import './home.css'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { NavButton } from 'src/components/navigation/nav'
import { Button, Dialog, IconButton, Menu, MenuItem } from '@mui/material'
import { Form } from 'src/components/form'
import { useNavigate } from 'react-router-dom'
import { NavigationASBO } from 'src/components/navigation-asbo/nav'
import { FooterAsbo } from 'src/components/footer-asbo/footer'
import PromoBlockASBO from 'src/components/PromoBlockASBO'

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef)

  return <div ref={someRef}>{isInViewport && children}</div>
}

export const HomeASBOPage = () => {
  const { t } = useTranslation()
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    document.title = 'Cyber Defense Center'
    return () => {
      document.title = 'Cyber Defence Centre'
    }
  }, [])

  const handleClick = () => {
    navigate('/asbo/book-a-demo')
  }

  return (
    <>
      <NavigationASBO
        theme={THEMES.dark}
        onOpenDemoModal={() => {
          setRequestDemoModalOpen(true)
        }}
      />
      <section className='dark heading-section asbo'>
        <div className='hide mob-show home-mob-main-img'></div>
        <div className='container'>
          <div className='row row-center mob-column-reverse mob-column-center'>
            <div className='column column-start one-of-2 mob-fullwidth mob-column-center' style={{ maxWidth: 400 }}>
              <h1 className='mob-text-center'>Gallagher Cyber Defence Centre</h1>

              <p
                className='mob-text-center heading-description mw371 mom-mw305'
                style={{ marginTop: '33px', color: '#5D5D5D', maxWidth: 400 }}
              >
                Gallagher's Cyber Defense Center is a collection of tools and services for Association of School
                Business Officials International (ASBO) members who want to take a proactive and continuous approach to
                managing their cyber risk. It includes access to cyber risk specialists and automated security
                technology to help you defend your organization against cyber incidents
              </p>

              <img
                src='/images/Partner_logos_Affinity.png'
                style={{ width: 200, marginTop: -20 }}
                className='mb20'
                alt=''
              />

              <Button
                sx={{
                  background: '#0075BC',
                  borderRadius: 0,
                  padding: '22px 35px',
                  letterSpacing: 1.6,
                  cursor: 'pointer',
                  width: '100%',
                  color: '#fff',
                  '&:hover': {
                    background: '#336791'
                  }
                }}
                // ref={btn}
                fullwidth
                onClick={handleClick}
                variant='dark'
                size='md'
              >
                Book a demo
              </Button>
            </div>
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>
              Cybersecurity risk prevention should be high on the list of priorities for school districts.
            </h2>
          </div>
          <div className='row space-between mob-column mob-margin-0'>
            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num'>
                {' '}
                <Intersector>
                  $<CountUp end={4} />
                  .44M
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 mw279'>The global average cost of a data breach</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num'>
                <Intersector>
                  <CountUp end={63} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 mw339 mob-mw299'>
                of organizations that lack AI governance policies
              </p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num'>
                <Intersector>
                  <CountUp duration={3} end={97} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 mw279 mob-mw245'>
                of organizations that reported an AI-related breach and lacked proper AI access controls
              </p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num'>
                <Intersector>
                  $<CountUp duration={3} end={3} />
                  .8M
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 mw279 mob-mw245'>
                Average cost of a data breach in education organizations
              </p>
            </div>
          </div>
          <p className='mt40 mob-mt-40 text-center'>
            *Source:{' '}
            <a
              style={{ color: '#0075BC' }}
              href='https://www.ibm.com/reports/data-breach'
              target='_blank'
              rel='noreferrer'
            >
              IBM Cost of a Data Breach Report 2025
            </a>
          </p>
        </div>
      </section>

      <section className='dark pt70 pb50'>
        <div className='container'>
          <div className='column'>
            <div className=' mb40 mob-mb-20 content-box secure-humans-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Building Cyber Resilience Together
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    The biggest contributor to cyber incidents is human vulnerability. Each month we will host a series
                    of cybersecurity training webinars designed for your employees at all levels of understanding.
                    Throughout the year, your staff can be trained by our specialist cybersecurity team in the role they
                    can play in defending your organization. Topics will include boundary control, email security and
                    phishing, working from home, data protection and more.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' '>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Continuous Vulnerability Scanning
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Our Cyber Defense team will monitor your external boundaries and provide you with updates as to
                      the known vulnerabilities with your technology portfolio. This report will outline where your low,
                      medium and high-risk technology vulnerabilities reside.
                    </p>
                  </div>
                </div>
              </div>

              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' '>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Threat Intelligence Webinars
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Forewarned is forearmed. As a cyber-insurance broker, we deal with a huge number of claims, and
                      from this, we gain extensive intelligence on the latest threats and methods of attack. We can
                      provide real-time updates on where your organization needs to be focusing its cyber defense
                      efforts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box newsletter-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 260 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth mob-content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Gallagher Cyber Risk Matters Newsletter
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    We will send you regular email updates on the latest cyber thinking so that you can stay informed.
                    We are in the age of information, and these key insights can support you to make key changes and
                    adaptions to your security efforts.
                  </p>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box virtual-cisco-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Virtual CISO
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    Gain access to a virtual Chief Information Security Officer (CISO) who will provide guidance and
                    support. Leverage their expertise to assess your current cybersecurity posture, develop strategies,
                    and address any concerns or questions you may have.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Community Intelligence
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      You will be part of a community of security professionals where your contribution counts. You will
                      be invited to monthly discussions about key security concerns and live threats your organization
                      needs to be aware of. We will be bringing forward thought leadership and solutions for network
                      configuration, technology optimization, risk management and risk transfer. As a collective, we are
                      stronger together in the offensive efforts against cyber criminals.
                    </p>
                  </div>
                </div>
              </div>
              <div className='one-of-2 mob-fullwidth content-box other-services-backgound'>
                <div className='row row-center space-between mob-column'>
                  <div className='hide mob-show' style={{ height: 270 }}></div>
                  <div className='  content-box-text'>
                    <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Other Security Services
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Take advantage of the wider security services the Gallagher Cyber Risk Management Practice
                      provides and receive preferential pricing as an ASBO member. Services such as penetration testing,
                      phishing simulations, ISO27001, incident response planning, maturity assessments and more, are all
                      available to you when you become part of our community.
                    </p>
                  </div>
                  <Spacer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pb150 mob-pb-20'>
        <PromoBlockASBO>
          <p className='sato34 mb36 font500 mob-mw263 mob-font-24'>{t('Connect with an expert')}.</p>
        </PromoBlockASBO>
      </section>

      <FooterAsbo theme={THEMES.dark} />

      <Dialog
        sx={{ '& .MuiPaper-root': { width: 500 } }}
        onClose={() => setRequestDemoModalOpen(false)}
        open={requestDemoModalOpen}
      >
        <div className='row' style={{ padding: '10px 10px 0px 0px' }}>
          <Spacer />
          <IconButton onClick={() => setRequestDemoModalOpen(false)}>
            <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.92358 6.75391L19.4236 19.2539' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
              <path d='M6.92358 19.2461L19.4236 6.7461' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
            </svg>
          </IconButton>
        </div>
        <Form onClose={() => setRequestDemoModalOpen(false)} />
      </Dialog>
    </>
  )
}
